import { createApiInstance } from './handler';
import { getGlobalValue, setGlobalValue } from '../utils/global-storage';

const STORED_CLIENT_CONFIGURATION = 'hutrics.client.configuration';

const DEFAULT_ORGANIZATIONAL_VALUES = {
  decisionAuthority: 3.6,
  listenToIdeas: 3.54,
  trainingOpportunities: 3.47,
  learning: 3.53,
  communication: 3.73,
  communityInvolvement: 3.12,
  ethics: 3.96,
  expectations: 3.87,
  inclusionDiversity: 3.64,
  manager: 3.93,
  performanceFeedback: 3.69,
  mission: 3.95,
  recognition: 3.24,
  technology: 3.32,
  safety: 4.32,
  seniorLeadershipVisibility: 3.36,
  coworkers: 3.74,
  workLifeBalance: 3.52,
};

export const retrieveClientConfiguration = async (auth) => {
  const response = await createApiInstance(auth).get('/client');
  if (response.data?.config_json) {
    setGlobalValue(STORED_CLIENT_CONFIGURATION, response.data.config_json);
  }
};

export const getLoginPrompts = (slug, cid) => {
  if (cid === '5f48cf8e-1192-4299-8d9a-d656412af134' || slug === 'commonspirit') {
    return {
      usernameLabel: 'Employee ID (EEID)',
      usernamePlaceholder: 'Employee ID (EEID)',
      passwordLabel: 'Date of Birth (MMDD)',
      passwordPlaceholder: 'Date of Birth (MMDD)',
    };
  } else if (cid === 'bc0094cf-5aea-4b61-b52b-d4457a11a40b' || slug === 'support-solutions') {
    return {
      usernameLabel: 'User Name (firstname.lastname)',
      usernamePlaceholder: 'User Name (firstname.lastname)',
      passwordLabel: 'Date of Birth (MMDD)',
      passwordPlaceholder: 'Date of Birth (MMDD)',
    };
  }
};

export const getClientConfiguration = () => {
  const storedConfig = getGlobalValue(STORED_CLIENT_CONFIGURATION);
  if (!storedConfig) {
    return null;
  }
  return JSON.parse(getGlobalValue(STORED_CLIENT_CONFIGURATION));
};

export const getClientOrgValues = () => {
  const config = getClientConfiguration();
  if (config?.orgValues) {
    return config.orgValues;
  }
  return DEFAULT_ORGANIZATIONAL_VALUES;
};

export const launchEnabled = (isDevelop) => {
  const config = getClientConfiguration();
  if (!config) {
    return false;
  }
  if (isDevelop) {
    return config?.develop?.launch?.assessments?.length > 0;
  } else {
    return config?.select?.launch?.assessments?.length > 0;
  }
};
